import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import {
  T, serif, fmt, Card, Chip, Boton, Campo, estiloInput,
  Titulo, Aviso, Vacio, Cargando,
} from '../lib/ui';
import { mensajeDeError } from './Gastos';
import { DocumentoImprimible } from './Documentos';
import { ConfirmarEliminar } from './Eliminar';

// ════════════════════════════════════════════════════════════════════
// Solicitudes de viaticos
// Reemplaza el formato SICREAFO34 que se llevaba en Excel.
// ════════════════════════════════════════════════════════════════════

const CONCEPTOS = [
  { campo: 'desayuno',   texto: 'Desayuno' },
  { campo: 'almuerzo',   texto: 'Almuerzo' },
  { campo: 'cena',       texto: 'Cena' },
  { campo: 'transporte', texto: 'Transporte' },
  { campo: 'agua',       texto: 'Agua' },
  { campo: 'otros',      texto: 'Otros' },
];

const ESTADO_CHIP = {
  borrador:  'borrador',
  enviada:   'enviado',
  aprobada:  'aprobado',
  rechazada: 'rechazado',
  entregada: 'aprobado',
  liquidada: 'contabilizado',
};

const num = (v) => Math.round((Number(v) || 0) * 100) / 100;
const personaVacia = () => ({
  nombre: '', desayuno: '', almuerzo: '', cena: '',
  transporte: '', agua: '', otros: '',
});
// Los montos son la TARIFA DIARIA de cada persona, igual que en el
// formato en papel: la fila dice "desayuno 15" y el subtotal sale de
// multiplicar por los dias del viaje.
const tarifaDiaria = (p) => num(CONCEPTOS.reduce((s, c) => s + (Number(p[c.campo]) || 0), 0));
const subtotal = (p, dias) => num(tarifaDiaria(p) * (dias || 1));

// ════════════════════════════════════════════════════════════════════
export function Viaticos({ usuario }) {
  const [lista, setLista] = useState(null);
  const [nueva, setNueva] = useState(false);
  const [abierta, setAbierta] = useState(null);
  const [aviso, setAviso] = useState(null);

  const cargar = () => api.viaticos()
    .then((r) => setLista(r.solicitudes || []))
    .catch((err) => { setAviso({ tipo: 'bad', texto: mensajeDeError(err) }); setLista([]); });

  useEffect(() => { cargar(); }, []);

  if (!lista) return <Cargando />;

  if (abierta) {
    return (
      <DetalleViatico
        id={abierta} usuario={usuario}
        onVolver={() => { setAbierta(null); cargar(); }}
      />
    );
  }

  return (
    <>
      <Titulo sub="Reemplaza el formato en Excel. Al aprobarse abre el encargo contra el que se rinde.">
        Viáticos
      </Titulo>

      {aviso && <Aviso tipo={aviso.tipo}>{aviso.texto}</Aviso>}

      <div style={{ marginBottom: 16 }}>
        <Boton variante={nueva ? 'suave' : 'acento'} onClick={() => setNueva(!nueva)}>
          {nueva ? 'Cancelar' : 'Nueva solicitud'}
        </Boton>
      </div>

      {nueva && (
        <FormViatico
          usuario={usuario}
          onListo={async (r) => {
            setNueva(false);
            setAviso({ tipo: 'ok', texto: `Solicitud ${r.numero} creada por ${fmt.money(r.total)}.` });
            await cargar();
          }}
          onError={(m) => setAviso({ tipo: 'bad', texto: m })}
        />
      )}

      {lista.length === 0
        ? <Vacio>Todavía no hay solicitudes de viáticos.</Vacio>
        : (
          <div style={{ display: 'grid', gap: 10 }}>
            {lista.map((s) => (
              <Card key={s.id} onClick={() => setAbierta(s.id)} style={{ padding: 15 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                      <Chip estado={ESTADO_CHIP[s.estado] || 'borrador'}>{s.estado}</Chip>
                      <span style={{ fontWeight: 600, fontSize: 14 }}>{s.numero}</span>
                    </div>
                    <div style={{ fontSize: 14 }}>{s.cliente || 'Sin cliente'}</div>
                    <div style={{ color: T.muted, fontSize: 12, marginTop: 2 }}>
                      {s.lugar || '—'} · {fmt.fecha(s.fechaInicio)} a {fmt.fecha(s.fechaFin)}
                      {' · '}{s.dias} día{s.dias > 1 ? 's' : ''}
                      {s.ovId ? ` · ${s.ovId}` : ''}
                    </div>
                  </div>
                  <div style={{
                    fontFamily: serif, fontSize: 19, fontWeight: 600,
                    color: T.navy, whiteSpace: 'nowrap',
                  }}>
                    {fmt.money(s.total, s.moneda)}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
    </>
  );
}

// ════════════════════════════════════════════════════════════════════
function FormViatico({ usuario, onListo, onError, inicial }) {
  const editando = Boolean(inicial?.solicitud);
  const [ovs, setOvs] = useState([]);
  const [equipo, setEquipo] = useState([]);
  // A quién se le puede depositar: TODOS los activos, no solo el
  // equipo propio. El que viaja no siempre le reporta a quien tramita.
  const [depositables, setDepositables] = useState([]);
  const [motivos, setMotivos] = useState([]);
  const [padron, setPadron] = useState([]);
  const s0 = inicial?.solicitud;
  const [f, setF] = useState({
    ovId: s0?.ovId || '', motivoSinOv: s0?.motivoSinOv || '',
    cliente: s0?.cliente || '', tipoOp: s0?.tipoOp || 'MANTENIMIENTO',
    lugar: s0?.lugar || '',
    fechaInicio: (s0?.fechaInicio || new Date().toISOString()).slice(0, 10),
    fechaFin: (s0?.fechaFin || new Date().toISOString()).slice(0, 10),
    moneda: s0?.moneda || 'PEN',
    cochera: s0 ? String(s0.cochera || '') : '',
    observaciones: s0?.observaciones || '',
    depositoA: s0?.depositoA || '', depositoNombre: s0?.depositoNombre || '',
  });
  const [personas, setPersonas] = useState(
    inicial?.personas?.length
      // Al editar se muestran las tarifas por día, que es como se
      // capturaron: el subtotal guardado ya viene multiplicado.
      ? inicial.personas.map((p) => ({
          nombre: p.nombre,
          ...Object.fromEntries(CONCEPTOS.map((c) => [
            c.campo, Number(p[c.campo]) > 0 ? String(p[c.campo]) : '',
          ])),
        }))
      : [personaVacia()],
  );
  const [ocupado, setOcupado] = useState(false);

  useEffect(() => {
    Promise.all([api.ovs(true), api.equipo(), api.catalogos(), api.personal(), api.depositables()])
      .then(([o, e, c, pr, dep]) => {
        setOvs(o.ovs || []);
        setEquipo(e.equipo || []);
        setDepositables(dep?.personas || e.equipo || []);
        setMotivos(c.motivosSinOv || []);
        setPadron(pr.personal || []);
      })
      .catch(() => {});
  }, []);

  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));

  // Al elegir OV se completa el cliente, como en el formato en papel.
  const elegirOv = (id) => {
    const ov = ovs.find((o) => o.id === id);
    setF((x) => ({
      ...x,
      ovId: id,
      motivoSinOv: id ? '' : x.motivoSinOv,
      cliente: ov ? ov.clienteAlias : x.cliente,
      tipoOp: ov ? (ov.tipo || x.tipoOp).toUpperCase() : x.tipoOp,
    }));
  };

  const setPersona = (i, campo, valor) =>
    setPersonas((ps) => ps.map((p, j) => (j === i ? { ...p, [campo]: valor } : p)));

  const dias = (() => {
    const a = new Date(f.fechaInicio); const b = new Date(f.fechaFin);
    return b < a ? 0 : Math.round((b - a) / 86400000) + 1;
  })();

  const totalPersonas = num(personas.reduce((s, p) => s + subtotal(p, dias), 0));
  // La cochera se suma una sola vez, no por dia.
  const total = num(totalPersonas + (Number(f.cochera) || 0));

  const porConcepto = CONCEPTOS.map((c) => ({
    ...c,
    suma: num(personas.reduce((s, p) => s + (Number(p[c.campo]) || 0), 0) * dias),
  }));

  const enviar = async (mandarAprobacion) => {
    const limpias = personas
      .filter((p) => p.nombre.trim())
      .map((p) => ({
        nombre: p.nombre.trim(),
        usuarioId: equipo.find((u) => u.nombre === p.nombre.trim())?.id || null,
        personalId: padron.find((x) => x.nombre === p.nombre.trim())?.id || null,
        ...Object.fromEntries(CONCEPTOS.map((c) => [c.campo, Number(p[c.campo]) || 0])),
      }));

    if (limpias.length === 0) return onError('Agrega al menos una persona con nombre.');
    if (total <= 0) return onError('El total no puede ser cero.');
    if (dias === 0) return onError('La fecha de fin no puede ser anterior a la de inicio.');

    setOcupado(true);
    try {
      const cuerpo = {
        ovId: f.ovId || null,
        motivoSinOv: f.ovId ? null : (f.motivoSinOv || null),
        cliente: f.cliente || null,
        tipoOp: f.tipoOp || null,
        lugar: f.lugar || null,
        fechaInicio: f.fechaInicio,
        fechaFin: f.fechaFin,
        moneda: f.moneda,
        cochera: Number(f.cochera) || 0,
        observaciones: f.observaciones || null,
        depositoA: f.depositoA || null,
        depositoNombre: f.depositoNombre || null,
        personas: limpias,
        enviar: mandarAprobacion,
      };
      const r = editando
        ? await api.editarViatico(s0.id, cuerpo)
        : await api.crearViatico(cuerpo);
      onListo(r);
    } catch (err) {
      onError(mensajeDeError(err));
      setOcupado(false);
    }
  };

  return (
    <Card style={{ marginBottom: 16 }}>
      <div style={{
        fontFamily: serif, fontSize: 18, color: T.navy,
        fontWeight: 600, marginBottom: 4,
      }}>
        {editando ? `Corregir viáticos ${s0.numero}` : 'Entrega de viáticos'}
      </div>
      <div style={{ color: T.muted, fontSize: 12, marginBottom: 16 }}>
        {editando
          ? 'Al guardar vuelve a la cola de aprobación'
          : 'Formato SICREAFO34 · el número se asigna solo'}
      </div>

      <Campo etiqueta="Orden de venta"
             ayuda="Al elegirla se completa el cliente y queda ligada la liquidación.">
        <select value={f.ovId} onChange={(e) => elegirOv(e.target.value)} style={estiloInput}>
          <option value="">Sin OV</option>
          {ovs.map((o) => (
            <option key={o.id} value={o.id}>{o.id} — {o.clienteAlias}</option>
          ))}
        </select>
      </Campo>

      {!f.ovId && (
        <Campo etiqueta="Motivo sin OV">
          <select value={f.motivoSinOv} onChange={(e) => set('motivoSinOv', e.target.value)}
                  style={estiloInput}>
            <option value="">Elegir…</option>
            {motivos.map((m) => <option key={m.valor} value={m.valor}>{m.texto}</option>)}
          </select>
        </Campo>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: 14 }}>
        <Campo etiqueta="Cliente">
          <input value={f.cliente} onChange={(e) => set('cliente', e.target.value)}
                 placeholder="CORPORACIÓN LINDLEY S.A." style={estiloInput} />
        </Campo>
        <Campo etiqueta="OP">
          <input value={f.tipoOp} onChange={(e) => set('tipoOp', e.target.value.toUpperCase())}
                 placeholder="MANTENIMIENTO" style={estiloInput} />
        </Campo>
      </div>

      <Campo etiqueta="Lugar">
        <input value={f.lugar} onChange={(e) => set('lugar', e.target.value)}
               placeholder="SAN JUAN DE LURIGANCHO" style={estiloInput} />
      </Campo>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', columnGap: 14, alignItems: 'end' }}>
        <Campo etiqueta="Del">
          <input type="date" value={f.fechaInicio}
                 onChange={(e) => set('fechaInicio', e.target.value)} style={estiloInput} />
        </Campo>
        <Campo etiqueta="Al">
          <input type="date" value={f.fechaFin}
                 onChange={(e) => set('fechaFin', e.target.value)} style={estiloInput} />
        </Campo>
        <div style={{ paddingBottom: 14, whiteSpace: 'nowrap' }}>
          <span style={{
            background: dias ? T.warnBg : T.badBg, color: dias ? T.warn : T.bad,
            padding: '9px 14px', borderRadius: 8, fontSize: 14, fontWeight: 600,
          }}>
            {dias} día{dias === 1 ? '' : 's'}
          </span>
        </div>
      </div>

      {/* ── Personas ── */}
      <div style={{
        fontSize: 12, fontWeight: 600, color: T.muted, textTransform: 'uppercase',
        letterSpacing: '.03em', margin: '18px 0 6px',
      }}>
        Personal · {personas.filter((p) => p.nombre.trim()).length}
      </div>
      <div style={{ fontSize: 12, color: T.muted, marginBottom: 10 }}>
        Escribe la tarifa <strong>por día</strong> de cada persona. La plataforma
        multiplica por los {dias} día{dias === 1 ? '' : 's'} del viaje.
      </div>

      {personas.map((p, i) => (
        <div key={i} style={{
          border: `1px solid ${T.border}`, borderRadius: 9,
          padding: 12, marginBottom: 10, background: T.warm,
        }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 10 }}>
            <span style={{
              fontFamily: serif, fontSize: 15, color: T.brass,
              fontWeight: 700, minWidth: 22,
            }}>
              {i + 1}
            </span>
            <input
              value={p.nombre} list="personal-sicrea"
              onChange={(e) => setPersona(i, 'nombre', e.target.value)}
              placeholder="Apellidos y nombres"
              style={{ ...estiloInput, flex: 1 }}
            />
            {personas.length > 1 && (
              <button onClick={() => setPersonas((ps) => ps.filter((_, j) => j !== i))}
                      style={{
                        border: 'none', background: 'none', color: T.bad,
                        fontSize: 20, cursor: 'pointer', padding: '0 6px',
                      }}>
                ×
              </button>
            )}
          </div>

          <div style={{
            display: 'grid', gap: 8,
            gridTemplateColumns: 'repeat(auto-fit, minmax(88px, 1fr))',
          }}>
            {CONCEPTOS.map((c) => (
              <label key={c.campo} style={{ fontSize: 11, color: T.muted }}>
                {c.texto}
                <input
                  inputMode="decimal" value={p[c.campo]}
                  onChange={(e) => setPersona(i, c.campo, e.target.value)}
                  placeholder="0.00"
                  style={{ ...estiloInput, padding: '7px 9px', fontSize: 14, marginTop: 3 }}
                />
              </label>
            ))}
          </div>

          <div style={{ textAlign: 'right', marginTop: 8, fontSize: 13, color: T.navy }}>
            {fmt.money(tarifaDiaria(p), f.moneda)} × {dias} día{dias === 1 ? '' : 's'}
            {' = '}<strong>{fmt.money(subtotal(p, dias), f.moneda)}</strong>
          </div>
        </div>
      ))}

      {/* El padrón cubre a todo el personal de obra, no solo a quienes
          tienen cuenta en la plataforma. */}
      <datalist id="personal-sicrea">
        {padron.map((p) => (
          <option key={p.id} value={p.nombre}>{`DNI ${p.dni}`}</option>
        ))}
        {equipo
          .filter((u) => !padron.some((p) => p.nombre === u.nombre))
          .map((u) => <option key={u.id} value={u.nombre} />)}
      </datalist>

      <Boton variante="suave" onClick={() => setPersonas((ps) => [...ps, personaVacia()])}
             style={{ width: '100%', marginBottom: 16 }}>
        Agregar persona
      </Boton>

      {/* ── Totales ── */}
      <div style={{
        background: T.navy, borderRadius: 10, padding: 15, marginBottom: 16,
      }}>
        <div style={{
          display: 'grid', gap: 6,
          gridTemplateColumns: 'repeat(auto-fit, minmax(92px, 1fr))',
          marginBottom: 10,
        }}>
          {porConcepto.map((c) => (
            <div key={c.campo} style={{ textAlign: 'center' }}>
              <div style={{ color: T.brass, fontSize: 10, letterSpacing: '.04em' }}>
                {c.texto.toUpperCase()}
              </div>
              <div style={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
                {c.suma.toFixed(2)}
              </div>
            </div>
          ))}
        </div>

        <div style={{
          borderTop: `1px solid ${T.navyAlt}`, paddingTop: 10,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
        }}>
          <label style={{ color: T.brass, fontSize: 12 }}>
            Cochera
            <input inputMode="decimal" value={f.cochera}
                   onChange={(e) => set('cochera', e.target.value)}
                   placeholder="0.00"
                   style={{ ...estiloInput, padding: '6px 9px', width: 92, marginLeft: 8 }} />
          </label>
          <div style={{ textAlign: 'right' }}>
            <div style={{ color: T.brass, fontSize: 11 }}>TOTAL</div>
            <div style={{ fontFamily: serif, fontSize: 26, fontWeight: 700, color: '#fff' }}>
              {fmt.money(total, f.moneda)}
            </div>
          </div>
        </div>
      </div>

      <Campo etiqueta="Depositar a"
             ayuda="A esta persona se le abre el encargo y es quien debe liquidar.">
        <select value={f.depositoA}
                onChange={(e) => {
                  const u = depositables.find((x) => x.id === e.target.value);
                  setF((x) => ({ ...x, depositoA: e.target.value, depositoNombre: u?.nombre || '' }));
                }}
                style={estiloInput}>
          <option value="">Yo mismo ({usuario.nombre})</option>
          {/* Toda la empresa, no solo el equipo propio: el que viaja a
              la obra no siempre le reporta a quien tramita el viático. */}
          {depositables
            .filter((u) => u.id !== usuario.id)
            .map((u) => (
              <option key={u.id} value={u.id}>
                {u.nombre}{u.centro ? ` · ${u.centro}` : ''}
              </option>
            ))}
        </select>
      </Campo>

      <Campo etiqueta="Observaciones">
        <textarea value={f.observaciones} rows={2}
                  onChange={(e) => set('observaciones', e.target.value)}
                  placeholder="Se debe rendir al término del trabajo."
                  style={{ ...estiloInput, resize: 'vertical' }} />
      </Campo>

      <div style={{ display: 'flex', gap: 10 }}>
        <Boton variante="suave" disabled={ocupado} style={{ flex: 1 }}
               onClick={() => enviar(false)}>
          {editando ? 'Guardar sin enviar' : 'Guardar borrador'}
        </Boton>
        <Boton variante="acento" disabled={ocupado} style={{ flex: 1 }}
               onClick={() => enviar(true)}>
          {ocupado ? 'Enviando…' : 'Enviar a aprobación'}
        </Boton>
      </div>
    </Card>
  );
}

// ════════════════════════════════════════════════════════════════════
function DetalleViatico({ id, usuario, onVolver }) {
  const [datos, setDatos] = useState(null);
  const [liq, setLiq] = useState(null);
  const [nota, setNota] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const [aviso, setAviso] = useState(null);
  const [imprimir, setImprimir] = useState(false);
  const [eliminando, setEliminando] = useState(false);
  const [editando, setEditando] = useState(false);

  const cargar = () => Promise.all([api.viatico(id), api.liquidacionViatico(id)])
    .then(([d, l]) => { setDatos(d); setLiq(l); })
    .catch((err) => { setAviso({ tipo: 'bad', texto: mensajeDeError(err) }); setDatos({}); });

  useEffect(() => { cargar(); }, [id]);   // eslint-disable-line react-hooks/exhaustive-deps

  if (!datos) return <Cargando />;
  const { solicitud: s, personas = [] } = datos;
  if (!s) return <Vacio>No se encontró la solicitud.</Vacio>;

  const puedeDecidir = s.estado === 'enviada'
    && ['mando_medio', 'director'].includes(usuario.rol)
    && (s.solicitante !== usuario.id || usuario.rol === 'director');

  const decidir = async (decision) => {
    if (decision === 'rechazar' && !nota.trim()) {
      return setAviso({ tipo: 'warn', texto: 'Indica el motivo del rechazo.' });
    }
    setOcupado(true);
    try {
      const r = await api.decidirViatico(id, decision, nota.trim() || undefined);
      setAviso(r.encargoId
        ? { tipo: 'ok', texto: `Aprobada. Se abrió el encargo ${r.encargoId}, a liquidar antes del ${fmt.fecha(r.vencimiento)}.` }
        : { tipo: 'ok', texto: 'Solicitud rechazada.' });
      setNota('');
      await cargar();
    } catch (err) {
      setAviso({
        tipo: 'bad',
        texto: err.message === 'monto_fuera_de_facultad'
          ? 'El monto excede tu facultad de aprobación. Debe aprobarlo la dirección.'
          : mensajeDeError(err),
      });
    }
    setOcupado(false);
  };

  return (
    <>
      <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
        <Boton variante="suave" onClick={onVolver}>← Volver</Boton>
        <Boton variante="suave" onClick={() => setImprimir(true)}>
          Imprimir y firmar
        </Boton>
        {['borrador', 'enviada', 'rechazada'].includes(s.estado) && (
          <Boton variante="suave" onClick={() => setEditando(true)}>
            Corregir
          </Boton>
        )}
        <Boton variante="suave" onClick={() => setEliminando(true)}>
          Eliminar
        </Boton>
      </div>

      {eliminando && (
        <ConfirmarEliminar
          titulo={`los viáticos ${s.numero}`}
          descripcion={`${(personas || []).length} persona(s) · ${fmt.money(s.total, s.moneda)}`}
          consultar={() => api.viaticoEliminable(id)}
          ejecutar={(motivo) => api.borrarViatico(id, motivo)}
          onCerrar={() => setEliminando(false)}
          onHecho={(r) => {
            setEliminando(false);
            if (r.accion === 'borrada') onVolver();
            else {
              setAviso({
                tipo: 'ok',
                texto: r.encargoCerrado
                  ? `Anulada. Se cerró también el encargo ${r.encargoCerrado}.`
                  : 'Solicitud anulada.',
              });
              cargar();
            }
          }}
        />
      )}

      {imprimir && (
        <DocumentoImprimible
          entidad="viatico" id={id}
          onCerrar={() => setImprimir(false)}
        />
      )}

      {editando && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 100, background: 'rgba(10,15,26,.55)',
          overflowY: 'auto', padding: '20px 14px',
        }} onClick={() => setEditando(false)}>
          <div onClick={(e) => e.stopPropagation()}
               style={{ maxWidth: 620, margin: '0 auto' }}>
            <FormViatico
              usuario={usuario}
              inicial={{ solicitud: s, personas }}
              onListo={async () => {
                setEditando(false);
                setAviso({ tipo: 'ok', texto: 'Solicitud corregida.' });
                await cargar();
              }}
              onError={(m) => setAviso({ tipo: 'bad', texto: m })}
            />
          </div>
        </div>
      )}

      <Titulo sub={`${s.cliente || 'Sin cliente'} · ${s.lugar || '—'}`}>
        Viáticos {s.numero}
      </Titulo>

      {aviso && <Aviso tipo={aviso.tipo}>{aviso.texto}</Aviso>}

      <Card style={{ marginBottom: 14 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          <div>
            <Chip estado={ESTADO_CHIP[s.estado] || 'borrador'}>{s.estado}</Chip>
            <div style={{ color: T.muted, fontSize: 12, marginTop: 6 }}>
              {fmt.fecha(s.fechaInicio)} a {fmt.fecha(s.fechaFin)} · {s.dias} día{s.dias > 1 ? 's' : ''}
              {s.ovId ? ` · ${s.ovId}` : ''}
            </div>
            {s.depositoNombre && (
              <div style={{ fontSize: 12, marginTop: 4 }}>
                Depositar a <strong>{s.depositoNombre}</strong>
              </div>
            )}
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontFamily: serif, fontSize: 24, fontWeight: 700, color: T.navy }}>
              {fmt.money(s.total, s.moneda)}
            </div>
            <div style={{ fontSize: 11, color: T.muted }}>presupuestado</div>
          </div>
        </div>
      </Card>

      {/* Comparacion con lo rendido */}
      {s.encargoId && liq && (
        <Card style={{ marginBottom: 14 }}>
          <div style={{
            fontSize: 11, color: T.muted, fontWeight: 600,
            letterSpacing: '.04em', marginBottom: 10,
          }}>
            LIQUIDACIÓN · encargo {s.encargoId}
          </div>
          <div style={{
            display: 'grid', gap: 10,
            gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
          }}>
            <Dato etiqueta="Entregado" valor={fmt.money(liq.entregado, s.moneda)} />
            <Dato etiqueta="Rendido" valor={fmt.money(liq.rendido, s.moneda)} />
            <Dato
              etiqueta="Por rendir"
              valor={fmt.money(liq.saldo, s.moneda)}
              color={liq.saldo > 0 ? T.warn : T.ok}
            />
            <Dato
              etiqueta="Vs presupuesto"
              valor={`${liq.diferenciaVsPresupuesto > 0 ? '+' : ''}${liq.diferenciaVsPresupuesto.toFixed(2)}`}
              color={liq.diferenciaVsPresupuesto > 0 ? T.bad : T.ok}
            />
          </div>
        </Card>
      )}

      {/* Personal */}
      <div style={{
        fontSize: 11, color: T.muted, fontWeight: 600,
        letterSpacing: '.04em', margin: '4px 0 10px',
      }}>
        PERSONAL · {personas.length}
      </div>

      <div style={{ display: 'grid', gap: 8, marginBottom: 16 }}>
        {personas.map((p, i) => (
          <Card key={p.id} style={{ padding: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>
                  {i + 1}. {p.nombre}
                </div>
                <div style={{ color: T.muted, fontSize: 11, marginTop: 3 }}>
                  {CONCEPTOS
                    .filter((c) => Number(p[c.campo]) > 0)
                    .map((c) => `${c.texto} ${Number(p[c.campo]).toFixed(2)}`)
                    .join(' · ') || 'Sin conceptos'}
                </div>
              </div>
              <div style={{ fontWeight: 600, color: T.navy, whiteSpace: 'nowrap' }}>
                {fmt.money(p.subtotal, s.moneda)}
              </div>
            </div>
          </Card>
        ))}
      </div>

      {Number(s.cochera) > 0 && (
        <div style={{ fontSize: 13, color: T.muted, marginBottom: 14 }}>
          Cochera: <strong>{fmt.money(s.cochera, s.moneda)}</strong>
        </div>
      )}

      {s.observaciones && (
        <Card style={{ marginBottom: 14, background: T.warm }}>
          <div style={{ fontSize: 11, color: T.muted, fontWeight: 600, marginBottom: 5 }}>
            OBSERVACIONES
          </div>
          <div style={{ fontSize: 13 }}>{s.observaciones}</div>
        </Card>
      )}

      {s.observacionAprobador && (
        <Aviso tipo={s.estado === 'rechazada' ? 'bad' : 'info'}>
          {s.observacionAprobador}
        </Aviso>
      )}

      {puedeDecidir && (
        <Card>
          <Campo etiqueta="Nota (obligatoria si rechazas)">
            <textarea value={nota} rows={2} onChange={(e) => setNota(e.target.value)}
                      style={{ ...estiloInput, resize: 'vertical' }} />
          </Campo>
          <div style={{ display: 'flex', gap: 8 }}>
            <Boton variante="exito" disabled={ocupado} style={{ flex: 1 }}
                   onClick={() => decidir('aprobar')}>
              Aprobar
            </Boton>
            <Boton variante="peligro" disabled={ocupado} style={{ flex: 1 }}
                   onClick={() => decidir('rechazar')}>
              Rechazar
            </Boton>
          </div>
        </Card>
      )}
    </>
  );
}

function Dato({ etiqueta, valor, color }) {
  return (
    <div>
      <div style={{ fontSize: 10, color: T.muted, letterSpacing: '.04em' }}>
        {etiqueta.toUpperCase()}
      </div>
      <div style={{ fontSize: 16, fontWeight: 600, color: color || T.navy, marginTop: 2 }}>
        {valor}
      </div>
    </div>
  );
}
